import { put } from 'redux-saga/effects';
import wait from '@signageos/lib/dist/Timer/wait';
import { StartApplication } from '@signageos/actions/dist/Application/applicationActions';
import { DEBOUNCE } from '../Intervals/constants';

export default function* startApplicationSaga() {
	// TODO: Make more complex solution of race condition during actions binding process
	// On Webos 4 managementSupports async driver method wastes some time thus some actions won't be bound
	yield wait(DEBOUNCE);
	yield put({ type: StartApplication } as StartApplication);
}
